import { RESET_PANEL_OPENED_STATE, UPDATE_PANEL_OPENED_STATE } from "../actionTypes/sidepanel";

const initialState = {
  isDashboardPanelOpened: true,
  isChartPanelOpened: true,
  isReportPanelOpened: true,
  isAnalyticsPanelOpened: true
};

const sidePanelData = (state = initialState, action) => {
  const updatePanel = action.payload;
  switch (action.type) {
    case UPDATE_PANEL_OPENED_STATE:
      return { ...state, ...updatePanel };
    case RESET_PANEL_OPENED_STATE:
      return initialState;
    default:
      return state;
  }
};

export default sidePanelData;
